import React from 'react'

function AdminFooter() {
  return (
    <div>AdminFooter</div>
  )
}

export default AdminFooter